module.exports = __webpack_public_path__ + "img/performers.0dbe11bf.png";